// views/Errors/SemPermissao.js
import React from 'react';

const SemPermissao = () => {
  return (
    <div style={{ padding: 24 }}>
      <h2>Acesso não autorizado</h2>
      <p>Você não possui permissão para acessar esta funcionalidade.</p>
    </div>
  );
};

export default SemPermissao;